import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    type: "image",
    src: "https://images.unsplash.com/photo-1630673287511-4d477913d7a0?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Empowering IT Careers",
    subtitle: "Innovative Solutions for a Digital Future",
  },
  {
    type: "image",
    src: "https://img.freepik.com/premium-photo/young-girl-coding-keyboard-generative-ai_972075-6506.jpg",
    title: "Opportunities Beyond IT",
    subtitle: "Non-IT Roles Tailored for You",
  },
  {
    type: "image",
    src: "https://learn.g2.com/hubfs/web_developer.jpg",
    title: "Skill Development",
    subtitle: "Upskilling for Career Growth",
  },
  {
    type: "image",
    src: "https://images.unsplash.com/photo-1583508915901-b5f84c1dcde1?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Connecting Talent & Industry",
    subtitle: "Your Gateway to Global Opportunities",
  },
];

export default function Carousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const renderMedia = () => {
    const current = slides[currentIndex];
    return current.type === "video" ? (
      <video
        key={currentIndex}
        src={current.src}
        autoPlay
        loop
        muted
        className="w-full h-[60vh] md:h-[75vh] lg:h-[90vh] object-cover transition-opacity duration-1000"
      />
    ) : (
      <img
        key={currentIndex}
        src={current.src}
        alt="carousel"
        className="w-full h-[60vh] md:h-[75vh] lg:h-[90vh] object-cover transition-opacity duration-1000"
      />
    );
  };

  return (
    <div className="relative w-full h-[60vh] md:h-[75vh] lg:h-[90vh] overflow-hidden">
      {/* Slide */}
      {renderMedia()}

      {/* Overlay */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-white text-center px-3 md:px-6 bg-black/40">
        <h4 className="text-sm md:text-lg font-light uppercase mb-2 md:mb-4 animate-fadeIn">
          {slides[currentIndex].subtitle}
        </h4>
        <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 animate-fadeIn delay-100">
          {slides[currentIndex].title}
        </h1>

        <div className="flex gap-2 md:gap-4 flex-wrap justify-center animate-fadeIn delay-300">
          <button
            onClick={() => navigate("/services")}
            className="border border-white px-4 py-2 md:px-6 md:py-3 rounded-xl shadow-lg text-sm md:text-base hover:bg-white hover:text-black transition transform hover:scale-105"
          >
            Explore Services
          </button>
          <button
            onClick={() => navigate("/contact")}
            className="border border-white px-4 py-2 md:px-6 md:py-3 rounded-xl shadow-lg text-sm md:text-base hover:bg-white hover:text-black transition transform hover:scale-105"
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Left Arrow */}
      <button
        onClick={() =>
          setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length)
        }
        className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 text-white text-xl md:text-3xl p-2 md:p-3 rounded-full bg-black/40 hover:bg-black/70 transition"
      >
        &#8249;
      </button>

      {/* Right Arrow */}
      <button
        onClick={() => setCurrentIndex((prev) => (prev + 1) % slides.length)}
        className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 text-white text-xl md:text-3xl p-2 md:p-3 rounded-full bg-black/40 hover:bg-black/70 transition"
      >
        &#8250;
      </button>

      {/* Bubbles */}
      <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 md:space-x-3">
        {slides.map((_, i) => (
          <div
            key={i}
            onClick={() => setCurrentIndex(i)}
            className={`w-2 h-2 md:w-4 md:h-4 rounded-full cursor-pointer transition-all duration-300 ${
              currentIndex === i
                ? "bg-cyan-500 scale-125 shadow-lg"
                : "bg-white/60 hover:bg-white"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
